/**
 * @module @shared/api/supabase
 * Zentraler Supabase-Cookie-Client (Cross-Subdomain-SSO) über das SDK.
 * Auch mit Platzhalter-Env wird der Client erzeugt — Requests scheitern dann
 * lediglich an der API-Boundary (sauber als Query-Error behandelt), die App
 * rendert trotzdem.
 */
import { createGlobalLoginClient } from '@repo/global-login-sdk';
import { globalLoginConfig } from '@shared/config';

/** Geteilter Auth-/Daten-Client gegen das zentrale `gmolike-id`-Projekt. */
export const supabase = createGlobalLoginClient(globalLoginConfig);
